module.exports = __webpack_public_path__ + "img/logo.bc1092f.png";